"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUltraRouters = void 0;
const react_query_1 = require("@tanstack/react-query");
const UltraSwapService_1 = require("src/data/UltraSwapService");
const useUltraRouters = (options) => {
    return (0, react_query_1.useQuery)(Object.assign({ queryKey: ['routers'], queryFn: () => UltraSwapService_1.ultraSwapService.getRouters(), cacheTime: Infinity, staleTime: Infinity }, options));
};
exports.useUltraRouters = useUltraRouters;
